import { UPLOAD_CONFIG } from '@/config';

export async function handleFileUpload(
  file: File, 
  maxSize: number,
  onError?: (error: string) => void
): Promise<string | null> {
  // Validate file type
  const isImage = UPLOAD_CONFIG.ACCEPTED_IMAGE_TYPES.includes(file.type as any);
  const isPDF = UPLOAD_CONFIG.ACCEPTED_PDF_TYPES.includes(file.type as any);

  if (!isImage && !isPDF) {
    onError?.('نوع الملف غير مدعوم');
    return null;
  }

  // Validate file size
  if (file.size > maxSize) {
    onError?.(`الملف كبير جداً. الحد الأقصى هو ${Math.round(maxSize / (1024 * 1024))}MB`);
    return null;
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => {
      onError?.('حدث خطأ أثناء قراءة الملف');
      resolve(null);
    };
    reader.readAsDataURL(file);
  });
}